export const initialState = {
  enabled: false,
  message: '',
}
